import request from '@/utils/request';
//优惠券通知消息列表
export function getQueryMessagePage(param) {
  return request('/coupon/queryMessagePage', {
    method: 'POST',
    data: param,
  });
}

//批量调整优惠券通知配置
export const batchMessageUpdate = (data) => {
  return request('/coupon/batchMessageUpdate', {
    method: 'POST',
    data,
  });
};

//删除礼品
export const deleteGift = (data) => {
  return request('/activityPoints/deleteGift', {
    method: 'POST',
    data,
  });
};
